// Rakenne (structure) — presented exactly like Kaksonen (SectionPanel groups wrapping the same
// EquipmentView / ZonesView), for a consistent look & feel across perspectives and with the
// Sijainnit panel. In config/operator mode these views carry create / edit / delete. The
// Konfigurointiassistentti is reached through Konfiguraatio's hero "Kysy agentilta" (the
// configuration lens agent profile) — no separate assistant control lives here.
import { useState } from "react";
import { Boxes, Grid3x3 } from "lucide-react";

import { EquipmentView } from "@/components/building/equipment/EquipmentView";
import { ZonesView } from "@/components/building/zones/ZonesView";
import { LocationsEditor } from "@/components/configuration/LocationsEditor";
import { DependencyTopologyEditor } from "@/components/configuration/DependencyTopologyEditor";
import { SectionPanel } from "@/components/ui/section-panel";

export function RakenneWorkspace({
  buildingId,
  operator,
  configurator,
  onChanged,
}: {
  buildingId: string;
  operator: boolean;
  configurator: boolean;
  onChanged?: () => void;
}) {
  // Talotekniikka, Vyöhykkeet and Sijainnit share this key so adding one (e.g. a Sijainti)
  // refreshes the others in step — Sijainnit is the single source of truth for locations.
  const [structureKey, setStructureKey] = useState(0);

  function bump() {
    setStructureKey((k) => k + 1);
    onChanged?.();
  }

  return (
    <div className="space-y-5">
      <SectionPanel icon={Boxes} title="Talotekniikka">
        <EquipmentView
          buildingId={buildingId}
          operator={operator}
          configurator={configurator}
          refreshKey={structureKey}
          onChanged={bump}
        />
      </SectionPanel>

      <SectionPanel icon={Grid3x3} title="Vyöhykkeet">
        <ZonesView
          buildingId={buildingId}
          operator={operator}
          refreshKey={structureKey}
          onChanged={bump}
        />
      </SectionPanel>

      <LocationsEditor
        buildingId={buildingId}
        operator={operator}
        refreshKey={structureKey}
        onChanged={bump}
      />

      <DependencyTopologyEditor
        buildingId={buildingId}
        configurator={configurator}
        refreshKey={structureKey}
        onChanged={bump}
      />
    </div>
  );
}
